import { Tooltip } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import * as S from '../ClientProfile.styled';

import { formatProfileValue, hasProfileValue, PROFILE_FIELD_LABEL_KEYS } from './profileFieldUtils';
import { RootState } from 'redux/store';

interface ProfileFieldRowProps {
    fieldKey: string;
    mobile: boolean;
    value: unknown;
}

export const ProfileFieldRow: React.FC<ProfileFieldRowProps> = ({ fieldKey, value, mobile }) => {
    const { language_setting: language } = useSelector((state: RootState) => state.user.entity);
    const { t } = useTranslation();

    if (!hasProfileValue(value)) {
        return null;
    }

    const labelKey = PROFILE_FIELD_LABEL_KEYS[fieldKey] ?? fieldKey;
    const label = t(labelKey, { lng: language });
    const display = formatProfileValue(value, t, language, fieldKey);

    return (
        <S.InfoItem>
            <Tooltip title={label}>
                <S.Label mobile={mobile}>{label}</S.Label>
            </Tooltip>
            <Tooltip title={display}>
                <S.Info mobile={mobile}>{display}</S.Info>
            </Tooltip>
        </S.InfoItem>
    );
};

interface ProfileFieldsProps {
    keys: readonly string[];
    mobile: boolean;
    record: object | null | undefined;
}

export const ProfileFields: React.FC<ProfileFieldsProps> = ({ record, keys, mobile }) => {
    if (!record) {
        return null;
    }

    const values = record as Record<string, unknown>;

    return (
        <>
            {keys.map((key) => (
                <ProfileFieldRow key={key} fieldKey={key} value={values[key]} mobile={mobile} />
            ))}
        </>
    );
};
